import React, { Component } from "react";
import Cookies from "universal-cookie";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import { Button, Col, Form, Input, InputNumber, Modal, Row, Select, Switch } from "antd";
import { TaxInManualCreditStates } from "./types/TaxInManualCreditTypes";
import { taxOtodisService } from "../../services/otodisApi/TaxOtodisService";
import { dealerApiService } from "../../services/otodis/DealerApiService";

export interface TaxInManualCreditProps {}

class UploadVatManual extends Component<TaxInManualCreditProps & any, TaxInManualCreditStates> {
  private readonly initState!: TaxInManualCreditStates;
  private token = new Cookies().get("_t");

  constructor(props: (TaxInManualCreditProps & any) | any) {
    super(props);

    this.initState = {
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
      in_submitting: false,
      in_switchReceiver: true,
      in_dealerReceiverName: "",
      in_dealerReceiverNpwp: "",
      in_receiverName: "",
      in_receiverNpwp: "",
      in_month: null,
      in_year: null,
      in_salesType: "CREDIT",
      in_orderCode: "",
      in_taxSection: null,
      in_ppn: 0,
    };
    this.state = { ...this.initState };
  }

  onDealerChange = async (data: any) => {
    this.setState({
      dealerCode: data.value,
    });
  };

  onFieldChange = <T extends keyof Pick<any, "in_month" | "in_year" | "in_ppn" | "in_receiverName" | "in_receiverNpwp" | "in_switchReceiver" | "in_orderCode" | "in_taxSection">>(
    target: T,
    value: any
  ) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "in_month":
        currentState.in_month = value;
        break;
      case "in_year":
        currentState.in_year = value;
        break;
      case "in_ppn":
        currentState.in_ppn = value;
        break;
      case "in_receiverName":
        currentState.in_receiverName = value;
        break;
      case "in_receiverNpwp":
        currentState.in_receiverNpwp = value;
        break;
      case "in_switchReceiver":
        currentState.in_switchReceiver = value;
        break;
      case "in_taxSection":
        currentState.in_taxSection = value;
        break;
      case "in_orderCode":
        currentState.in_orderCode = value;
        break;
    }
    this.setState({
      ...currentState,
    });
  };

  inputVatManual = async () => {
    if (!this.state.in_month || !this.state.in_year || !this.state.in_taxSection) {
      Modal.error({
        title: "Proses Gagal",
        content: "Mohon Lengkapi Data",
      });
      return;
    }
    await this.promisedSetState({
      in_submitting: true,
    });

    try {
      taxOtodisService.setToken(this.token);
      await taxOtodisService
        .addTaxManual({
          dealer_code: this.state.dealerCode,
          receiver_name: this.state.in_switchReceiver ? this.state.in_dealerReceiverName : this.state.in_receiverName,
          receiver_npwp: this.state.in_switchReceiver ? this.state.in_dealerReceiverNpwp : this.state.in_receiverNpwp,
          tax_section: this.state.in_taxSection,
          tax_year: this.state.in_year,
          tax_month: this.state.in_month,
          order_ppn: this.state.in_ppn,
          type: "CREDIT",
        })
        .then(async (successData) => {
          Modal.success({
            title: "Proses Sukses",
            content: "Berhasil ditambahkan ",
          });
          await this.promisedSetState({
            in_submitting: false,
            in_switchReceiver: true,
            in_receiverName: "",
            in_receiverNpwp: "",
            in_month: null,
            in_year: null,
            in_salesType: "CREDIT",
            in_orderCode: "",
            in_taxSection: null,
            in_ppn: 0,
          });
        });
    } catch (e) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda : " + e,
      });
      await this.promisedSetState({
        in_submitting: false,
      });
    }
  };

  fetchDealerData = async () => {
    try {
      await dealerApiService.getDealer({}).then(async (response) => {
        for (const item of response?.data?.data) {
          if (item?.dealer_code === this.state.dealerCode) {
            await this.promisedSetState({
              in_dealerReceiverName: item?.vat_account_name,
              in_dealerReceiverNpwp: item?.vat_account_number,
            });
          }
        }
      });
    } catch (e) {
      console.log(e);
    }
  };

  async componentDidMount() {
    await this.fetchDealerData();
  }

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    const currentYear: number = new Date().getFullYear();
    const years: number[] = Array.from({ length: 6 }, (_, index) => currentYear - index);

    return (
      <React.Fragment>
        <MainLayout
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Tax IN`}
          breadcrumbMenu={`Tax Manual Credit`}
          defaultSelectedKeys={["m-tax-in-insert-tax-manual-credit"]}
          defaultOpenKeys={["sm-tax-in"]}
        >
          <Row>
            <Col xl={{ span: 14 }} lg={{ span: 114 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
              <Form layout="vertical">
                <Row>
                  <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item>
                      <div style={{ float: "right" }}>
                        <Switch
                          checked={this.state.in_switchReceiver}
                          onChange={(value) => this.onFieldChange("in_switchReceiver", value)}
                          checkedChildren=" Receiver Dealer "
                          unCheckedChildren=" Receiver Manual Input "
                        />
                      </div>
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 2 }}>
                    <Form.Item style={this.state.in_switchReceiver ? {} : { display: "none" }}>
                      <span className={`text-small-grey-nopadding`}>Nama Receiver</span>
                      <Input value={this.state.in_dealerReceiverName} disabled={true} />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 2 }}>
                    <Form.Item style={this.state.in_switchReceiver ? {} : { display: "none" }}>
                      <span className={`text-small-grey-nopadding`}>NPWP Receiver</span>
                      <Input value={this.state.in_dealerReceiverNpwp} disabled={true} />
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 2 }}>
                    <Form.Item style={this.state.in_switchReceiver ? { display: "none" } : {}}>
                      <span className={`text-small-grey-nopadding`}>Nama Receiver</span>
                      <Input value={this.state.in_receiverName} placeholder="Nama Receiver" onChange={(event) => this.onFieldChange("in_receiverName", event.target.value)} />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 2 }}>
                    <Form.Item style={this.state.in_switchReceiver ? { display: "none" } : {}}>
                      <span className={`text-small-grey-nopadding`}>NPWP Receiver</span>
                      <Input value={this.state.in_receiverNpwp} placeholder="NPWP Receiver" onChange={(event) => this.onFieldChange("in_receiverNpwp", event.target.value)} />
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 2 }}>
                    <Form.Item>
                      <span className={`text-small-grey-nopadding`}>Tahun</span>
                      <Select placeholder="Tahun" showSearch optionFilterProp="children" onChange={(value) => this.onFieldChange("in_year", value)} value={this.state.in_year}>
                        {years.map((year) => (
                          <Select.Option key={year} value={year}>
                            {year}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 2 }}>
                    <Form.Item>
                      <span className={`text-small-grey-nopadding`}>Bulan</span>
                      <Select placeholder="Bulan" showSearch optionFilterProp="children" onChange={(value) => this.onFieldChange("in_month", value)} value={this.state.in_month}>
                        <Select.Option key={`01`} value={`01`}>{`Jan`}</Select.Option>
                        <Select.Option key={`02`} value={`02`}>{`Feb`}</Select.Option>
                        <Select.Option key={`03`} value={`03`}>{`Mar`}</Select.Option>
                        <Select.Option key={`04`} value={`04`}>{`Apr`}</Select.Option>
                        <Select.Option key={`05`} value={`05`}>{`Mei`}</Select.Option>
                        <Select.Option key={`06`} value={`06`}>{`Jun`}</Select.Option>
                        <Select.Option key={`07`} value={`07`}>{`Jul`}</Select.Option>
                        <Select.Option key={`08`} value={`08`}>{`Aug`}</Select.Option>
                        <Select.Option key={`09`} value={`09`}>{`Sep`}</Select.Option>
                        <Select.Option key={`10`} value={`10`}>{`Oct`}</Select.Option>
                        <Select.Option key={`11`} value={`11`}>{`Nov`}</Select.Option>
                        <Select.Option key={`12`} value={`12`}>{`Dec`}</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 2 }}>
                    <Form.Item>
                      <span className={`text-small-grey-nopadding`}>Section</span>
                      <Select placeholder="Tax Section" showSearch optionFilterProp="children" onChange={(value) => this.onFieldChange("in_taxSection", value)} value={this.state.in_taxSection}>
                        <Select.Option key={`iB1`} value={`iB1`}>{`iB1`}</Select.Option>
                        <Select.Option key={`iB2`} value={`iB2`}>{`iB2`}</Select.Option>
                        <Select.Option key={`iiB`} value={`iiB`}>{`iiB`}</Select.Option>
                        <Select.Option key={`iiiB1`} value={`iiiB1`}>{`iiiB1`}</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 2 }}>
                    <Form.Item>
                      <span className={`text-small-grey-nopadding`}>Nilai PPN</span>
                      <InputNumber
                        style={{ width: "100%" }}
                        className={"ant-input"}
                        value={this.state.in_ppn}
                        onChange={(value) => this.onFieldChange("in_ppn", value ? parseFloat(value) : 0)}
                        min={1}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Button type={"primary"} loading={this.state.in_submitting} onClick={() => this.inputVatManual()}>
                  Tambahkan
                </Button>
              </Form>
            </Col>
          </Row>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(UploadVatManual), 33);
